<template>
  <div
    class="calls-section"
    :class="isContrast != 'false' && isContrast != false ? 'high-contrast' : ''"
  >
    <DxTabPanel
      width="100%"
      :animation-enabled="false"
      :hover-state-enabled="false"
      :swipe-enabled="false"
      item-template="tabPanel"
      tabs-position="left"
      styling-mode="secondary"
      :items="timeScopeOptions"
      v-model:selected-index="selectedTabIndex"
      :no-data-text="t('scheme_details.no_open_openings_or_current_deadlines')"
      class="calls-tab-panel"
    >
      <template #tabPanel>
        <CallsCardView
          @items-loaded="$emit('items-loaded', $event)"
          :selectedTabIndex="selectedTabIndex"
          :parentSchemeId="parentSchemeId"
        />
      </template>
    </DxTabPanel>
  </div>
</template>

<script>
import { ref, computed, inject, onMounted, provide } from "vue";
import store from "../store/index";
import GrantsService from "../services/grants.service";
import { useI18n } from "vue-i18n";
import { DxTabPanel } from "devextreme-vue/tab-panel";
import CallsCardView from "./CallsCardView.vue";
import ETimeScope from "../enums/ETimeScope";

export default {
  name: "Calls",
  components: {
    CallsCardView,
    DxTabPanel,
  },
  setup() {
    const { t } = useI18n();
    const isVind = inject("isVind");
    const selectedTabIndex = ref(0);

    provide("isVind", isVind);

    onMounted(async () => {
      GrantsService.getCallTimeScopes();
    });

    const parentScheme = computed(
      () => store.state.grantItems.selectedGrant ?? {},
    );

    const parentSchemeId = computed(() => parentScheme.value.id);

    const getCountForTimeScope = (timeScopeId) => {
      if (timeScopeId === ETimeScope.Active)
        return parentScheme.value.countOfActiveOpenings ?? 0;

      if (timeScopeId === ETimeScope.Past)
        return parentScheme.value.countOfPastOpenings ?? 0;

      if (timeScopeId === ETimeScope.Future)
        return parentScheme.value.countOfFutureOpenings ?? 0;

      return 0;
    };

    const timeScopeOptions = computed(() =>
      store.state.grantItems.timeScopeOptions.map((item) => ({
        ...item,
        title: `${item.description} (${getCountForTimeScope(item.id)})`,
      })),
    );

    const isContrast = computed({
      get: () => store.state.user.isSelectedThemeContrast,
    });

    return {
      t,
      isContrast,
      isVind,
      timeScopeOptions,
      parentSchemeId,
      selectedTabIndex,
    };
  },
};
</script>
